module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "popover",
    staticClass: "popover bs-tether-element bs-tether-element-attached-top bs-tether-element-attached-center bs-tether-target-attached-bottom bs-tether-target-attached-center fade bs-tether-enabled show"
  }, [_c('div', {
    staticClass: "popover-content"
  }, [_c('div', {
    staticClass: "category-area"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [_vm._l((_vm.event.categories), function(category) {
    return [_c('router-link', {
      staticClass: "list-group-item first-level",
      attrs: {
        "tag": "li",
        "to": {
          query: {
            firstCategoryId: category.id
          }
        },
        "append": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectCategory($event)
        }
      }
    }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _vm._l((category.children), function(category2) {
      return [_c('router-link', {
        staticClass: "list-group-item second-level",
        attrs: {
          "tag": "li",
          "to": {
            query: {
              firstCategoryId: category.id,
              secondCategoryId: category2.id
            }
          },
          "append": ""
        },
        nativeOn: {
          "click": function($event) {
            _vm.selectCategory($event)
          }
        }
      }, [_vm._v(_vm._s(category2.name))]), _vm._v(" "), _vm._l((category2.children), function(category3) {
        return [_c('router-link', {
          staticClass: "list-group-item third-level",
          attrs: {
            "tag": "li",
            "to": {
              query: {
                firstCategoryId: category.id,
                secondCategoryId: category2.id,
                thirdCategoryId: category3.id
              }
            },
            "append": ""
          },
          nativeOn: {
            "click": function($event) {
              _vm.selectCategory($event)
            }
          }
        }, [_vm._v(_vm._s(category3.name))])]
      })]
    })]
  })], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f71484be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popover/CategoryPopover.vue
// module id = 741
// module chunks = 0